import { Box, Button, Checkbox, Chip, FormControlLabel, InputLabel, FormControl, Select, TextField, Typography, MenuItem, OutlinedInput } from '@mui/material'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { styled } from '@mui/material/styles';
import PushPinIcon from '@mui/icons-material/PushPin';

import ClearIcon from '@mui/icons-material/Clear';
import { createArticle, updateArticle } from '../../../../actions/article.js';
import { useDispatch } from 'react-redux';

import AddLinkIcon from '@mui/icons-material/AddLink';
import QuillEditor from './QuillEditor.js';
import { extractImagesFromContent, uploadImages } from './imageResolver.js';
import MultiSelectTags from '../helpers/MultiSelectTags.js';




const defaultData = {
  title: '', 
  content: '', 
  image: '', 
  imageUrl: undefined, 
  isPin: false, 

  tags : []

 // displayDate: new Date()
};



const Input = styled('input')({
  display: 'none',
});

const LiveArticle = ({match, onSubmit, initial = defaultData, isEditing = false}) => {

  const inputRef = React.useRef();
  const fileRef = React.useRef();
  
  const dispatch = useDispatch()

  const [articleData, setArticleData] = useState(initial)

  const [imgPreview, setImgPreview] = useState(initial.imageUrl)

  useEffect(() => {
    // Si dans articleData.tags on a un ID qui n'est plus dans match.tags, on le retire de articleData
    const newTags = articleData.tags ? articleData.tags.filter(t => match.tags.find(tag => tag._id === t)) : []

    setArticleData(s => ({...s, tags : newTags}))

  }, [match.tags])


  const handleChangeContent = (content) => {
    setArticleData(s => ({...s, content}))
  }
  
  const handleChange = (e) => {
      setArticleData(s => ({...s, [e.target.name]: e.target.value}))
  }

  const onChangePin = (e) => {
    setArticleData(s => ({...s, isPin: e.target.checked}))
  }

  const onChangeDisplayDate = (newDate) => {
    setArticleData(s => ({ ...s, displayDate: newDate }));
  };

  const handleSelectFile = (e) => {

    var file = e.target.files[0];
    setArticleData(s => ({...s, image: file}))
  }

  useEffect(() => {
    // FileReader support
    if (FileReader && articleData.image) {
      var fr = new FileReader();
      fr.onload = function () {
        setImgPreview(fr.result)
      }
      fr.readAsDataURL(articleData.image);
  }
  }, [articleData.image])

  const handleDeleteFile = (e) => {
    setArticleData(s => ({...s, image: '', imageName : '', imageUrl : ''}))
    setImgPreview(undefined)
  }

  const handleSubmit = async () => {

    let idEvent = match.idMatch || match.idActu;
    // Avant de submit, on doit envoyer les images au serveur, qu'il les enregistre et nous les retourne.
    const imagesToSave = await extractImagesFromContent(articleData.content, idEvent.toString() + "_" + new Date().getTime())

    let contentToSend = articleData.content

    if(imagesToSave.length > 0){
      const imageUrls = await uploadImages(imagesToSave)
    
      imageUrls.forEach(image => {
        const {imageUrl, imageName} = image
  
        // on recherche dans images toSave la base64 
        //dont imagestosave.imageName === imageName
        
        const associatedImage = imagesToSave.find(its => its.imageName === imageName)
  
        // en replace son base64 dans content par son url
        // Remplacez toutes les occurrences de la base64 par l'URL dans le contenu
        
        contentToSend = contentToSend.replace(associatedImage.toBeReplaced, imageUrl);
      })
    }
    
    //Ensuite on remplace dans le content les bases64 par les url
    // Et enfin on envoit le content au serveur dans le article
    isEditing ? dispatch(updateArticle({...articleData, content : contentToSend}, articleData._id)) : dispatch(createArticle({...articleData, content : contentToSend}, match))

    setArticleData(defaultData)
    onSubmit()
  }

  const handleTagChange = (event) => {
    setArticleData(s => ({ ...s, tags: event.target.value })); // Mettre à jour directement les tags dans articleData
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const [linkInfo, setLinkInfo] = useState({label : '', url : ''})

  const openPopper = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  }

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;

  const addLink = () => {
    const {label, url} = linkInfo
    if(!label || !url)
      return

    const cursorPos = inputRef.current.selectionStart ? inputRef.current.selectionStart : 0

    let newContent = articleData.content;
    newContent = newContent.slice(0, cursorPos) + ' <a href="'+url+'" target="_blank">'+label+'</a>' + newContent.slice(cursorPos);

    setArticleData(s => ({...s, content : newContent}))

    setLinkInfo({label : '', url : ''})
    openPopper()
  }

    return (
      <Box sx={{display : 'flex', flexDirection : 'column', justifyContent : 'center', padding: '1rem'}}>
        <Box sx={{marginBottom: 1, marginTop: 1}}>
        <Typography
          variant="h6"
          display="flex"
          alignItems="center"
          sx={{ paddingBottom: '1rem', fontWeight: 'bold' }}
        >
          Configuration générale
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: 2,
            flexDirection: {
              xs: 'column', // colonne en dessous de 650px
              sm: 'row' // ligne à partir de 650px et plus large
            },
          }}
        >
          <Box>
            <Typography component="span" display="flex" alignItems="center" sx={{ paddingLeft: '2px' }}>
              Date et heure
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DateTimePicker
                value={articleData.displayDate ?? articleData.creation}
                onChange={onChangeDisplayDate}
                inputFormat="dd/MM/yyyy HH:mm"
                renderInput={(params) => <TextField {...params} fullWidth sx={{ maxWidth: 250 }} />}
              />
            </LocalizationProvider>
          </Box>

          <Box>
              <FormControlLabel
                control={
                  <Checkbox checked={articleData.isPin} onChange={onChangePin} name="iPin" />
                }
                label={
                  <Typography component="span" display="flex" alignItems="center">
                    <PushPinIcon fontSize="small" style={{ marginRight: 4, color: 'black' }} />
                    Epingler l'article
                  </Typography>
                }
                sx={{
                  ml: { sm: 'auto', xs: 0 }, // Ajuste le margin selon la taille de l'écran
                  mt: { xs: 2, sm: 0 }, // Ajoute un espace au-dessus pour les petits écrans
                }}
              />

                {/* Select Multiple for Tags */}
                <MultiSelectTags match={match} tags={articleData.tags} handleTagChange={handleTagChange}/>


          </Box>

        </Box>


        </Box>

        
          

          <Box sx={{marginBottom: 2, marginTop: 2}}>
          <Typography variant='h6' display="flex" alignItems="center" sx={{paddingTop:'1rem', paddingBottom:'1rem', fontWeight:'bold'}} >Contenu de l'article</Typography>
          <QuillEditor content={articleData.content} onChange={handleChangeContent}/>
          </Box>

                 

                  <Button variant="contained" component="div" onClick={handleSubmit}>
                        Enregistrer {isEditing ? "les modifications" : "l'article"}
                  </Button>

        </Box>
    )

}

export default LiveArticle